import React, { Component } from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import CardsList from '../../components/CardsList/CardsList';
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import {REQUEST_AWARDS_DATA} from "../../actions/awardsActions";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import store from "../../store";
import {Helmet} from "react-helmet";

const mapStateToProps = state => {
  return {
    awardsData: state.awardsData
  }
};

const mapDispatchToProps = dispatch => ({
  getAwardsData: () => dispatch({type: REQUEST_AWARDS_DATA})
});

class Awards extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.awardsData).length) {
      this.props.getAwardsData();
    }
  };

  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "About" ? row.sections.map((section) => {
                          return section.title === "Awards" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL" />}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR" />}
          templateUrl="./content/about/page-components/text-block/awards-heading.html"
        />
        <CardsList
          layoutData={Object.keys(this.props.awardsData).length ? this.props.awardsData.awards : null}
          pathForItem="/about/awards/award"
          hasViewSwitcher={true}
          hasCardsView={true}
          showDatesOfIndividualContent={false}
        />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Awards));



// WEBPACK FOOTER //
// ./src/pages/About/Awards.js